// src/utils/sentenceDataLoader.ts
import sentenceData from '@/data/sentenceData.json'
import type { 
  SentenceDataStructure, 
  ThemeData, 
  MoodState, 
  ComplexityLevel,
  SentenceTemplate 
} from '@/types/sentenceTypes'

const data = sentenceData as SentenceDataStructure

export class SentenceDataLoader {
  static getThemeData(themeId: string): ThemeData | null {
    return data.themes[themeId] || null
  }

  /**
   * Get templates by difficulty level
   * Maps mood → difficulty: overwhelmed=easy, neutral/focused=regular, calm/high-energy=challenge
   */
  static getTemplatesForMood(
    themeId: string, 
    mood: MoodState
  ): SentenceTemplate[] {
    const theme = this.getThemeData(themeId)
    if (!theme) return []
    
    // Map mood to difficulty
    const difficultyMap: Record<MoodState, DifficultyLevel> = {
      'overwhelmed': 'easy',
      'neutral': 'regular',
      'calm': 'challenge'
    }
    
    const difficulty = difficultyMap[mood]
    return theme[difficulty] || []
  }
  
  /**
   * Get templates by explicit difficulty level
   */
  static getTemplatesByDifficulty(
    themeId: string,
    difficulty: DifficultyLevel
  ): SentenceTemplate[] {
    const theme = this.getThemeData(themeId)
    if (!theme) return []
    return theme[difficulty] || []
  }
}